import { ReactNode } from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { Logo, theme } from '@socrait/react';

import SparklesSvg from './sparkles.svg';

type SetupPageShellProps = {
  /** Optional element rendered above the main content (e.g. progress indicator). */
  header?: ReactNode;
  /** Main page body. */
  children: ReactNode;
  /** Bottom button bar contents. */
  buttons: ReactNode;
  /** Optional element rendered alongside the content (e.g. a modal). */
  overlay?: ReactNode;
};

export function SetupPageShell({ header, children, buttons, overlay }: SetupPageShellProps) {
  return (
    <View style={styles.container}>
      <Image source={{ uri: SparklesSvg }} style={styles.background} resizeMode="contain" />
      <View style={styles.logoContainer}>
        <Logo height={38} width={38} />
      </View>
      <View style={styles.contentContainer}>
        {header}
        {children}
        <View style={styles.buttonContainer}>{buttons}</View>
      </View>
      {overlay}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  background: {
    position: 'absolute',
    zIndex: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  logoContainer: {
    position: 'absolute',
    top: theme.spacing.xxlarge,
    left: theme.spacing.xxlarge,
    zIndex: 1,
  },
  contentContainer: {
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing.xxlarge,
    gap: theme.spacing.xlarge,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
});
